// Decorative backdrop for dark page-header banners (sits behind the banner text).
export default function BannerArt() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 85% 20%, rgba(249,220,42,0.16) 0%, transparent 55%)' }} />
      <svg className="absolute right-0 top-0 h-full w-auto min-w-[55%] opacity-[0.16]" viewBox="0 0 600 400" preserveAspectRatio="xMaxYMid slice" fill="none" stroke="#F9DC2A" strokeWidth="1.2">
        <circle cx="520" cy="200" r="90" />
        <circle cx="520" cy="200" r="150" />
        <circle cx="520" cy="200" r="210" />
        <circle cx="520" cy="200" r="270" />
        {/* wheat stalk */}
        <g strokeLinecap="round" strokeLinejoin="round" transform="translate(470 330) rotate(-18)">
          <path d="M0 0V-250" />
          {[0, 1, 2, 3, 4, 5, 6].map((i) => (
            <g key={i}>
              <path d={`M0 ${-120 - i * 18}C-22 ${-132 - i * 18} -26 ${-156 - i * 18} -26 ${-156 - i * 18}C-8 ${-150 - i * 18} 0 ${-120 - i * 18} 0 ${-120 - i * 18}Z`} />
              <path d={`M0 ${-120 - i * 18}C22 ${-132 - i * 18} 26 ${-156 - i * 18} 26 ${-156 - i * 18}C8 ${-150 - i * 18} 0 ${-120 - i * 18} 0 ${-120 - i * 18}Z`} />
            </g>
          ))}
        </g>
      </svg>
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(#FDF8F2 1px, transparent 1px)', backgroundSize: '22px 22px' }} />
    </div>
  );
}
